/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTournamentTransaction
 */
export interface UserTournamentTransaction {
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTransaction
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTransaction
     */
    type: UserTournamentTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentTransaction
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTransaction
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTransaction
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTransaction
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTransaction
     */
    tournamentName?: string;
}


/**
 * @export
 */
export const UserTournamentTransactionTypeEnum = {
    deposit: 'deposit',
    withdrawal: 'withdrawal',
    prize: 'prize',
    entry_fee: 'entry_fee',
    refund: 'refund',
    penalty: 'penalty'
} as const;
export type UserTournamentTransactionTypeEnum = typeof UserTournamentTransactionTypeEnum[keyof typeof UserTournamentTransactionTypeEnum];


/**
 * Check if a given object implements the UserTournamentTransaction interface.
 */
export function instanceOfUserTournamentTransaction(value: object): value is UserTournamentTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    return true;
}

export function UserTournamentTransactionFromJSON(json: any): UserTournamentTransaction {
    return UserTournamentTransactionFromJSONTyped(json, false);
}

export function UserTournamentTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTournamentTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'amount': json['amount'],
        'description': json['description'],
        'date': json['date'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
    };
}

export function UserTournamentTransactionToJSON(json: any): UserTournamentTransaction {
    return UserTournamentTransactionToJSONTyped(json, false);
}

export function UserTournamentTransactionToJSONTyped(value?: UserTournamentTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'amount': value['amount'],
        'description': value['description'],
        'date': value['date'],
        'tournamentId': value['tournamentId'],
        'tournamentName': value['tournamentName'],
    };
}

